// src/Step2UserInfo.jsx
import React from 'react';

export default function Step2UserInfo({ form, setF, colors }) {
  return (
    <div>
      <div
        className="mb-5 rounded-2xl border p-4"
        style={{
          borderColor: colors.border,
          backgroundColor: 'rgba(255,255,255,0.03)',
        }}
      >
        <h3 className="text-lg md:text-xl font-black mb-2">
          اطلاعات پایه بدنت
        </h3>

        <p className="text-sm leading-7" style={{ color: colors.sub }}>
          این اطلاعات برای محاسبه سطح برنامه، شدت تمرین و تنظیم رژیم استفاده می‌شود.
        </p>
      </div>

      <FieldLabel colors={colors}>جنسیت</FieldLabel>

      <div className="grid grid-cols-2 gap-3 mb-5">
        <ChoiceCard
          active={String(form.gender) === '0'}
          title="مرد"
          icon="👨"
          onClick={() => setF('gender', '0')}
          colors={colors}
        />

        <ChoiceCard
          active={String(form.gender) === '1'}
          title="زن"
          icon="👩"
          onClick={() => setF('gender', '1')}
          colors={colors}
        />
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <FieldLabel colors={colors}>سن</FieldLabel>
          <AppInput
            value={form.age}
            onChange={(v) => setF('age', normalizeNumber(v))}
            placeholder="مثلاً ۳۰"
            colors={colors}
          />
          <InputHint colors={colors}>بین ۱۸ تا ۷۰ سال</InputHint>
        </div>

        <div>
          <FieldLabel colors={colors}>قد</FieldLabel>
          <AppInput
            value={form.height}
            onChange={(v) => setF('height', normalizeNumber(v))}
            placeholder="مثلاً ۱۷۸"
            colors={colors}
          />
          <InputHint colors={colors}>بر حسب سانتی‌متر</InputHint>
        </div>

        <div>
          <FieldLabel colors={colors}>وزن</FieldLabel>
          <AppInput
            value={form.weight}
            onChange={(v) => setF('weight', normalizeNumber(v))}
            placeholder="مثلاً ۷۶"
            colors={colors}
          />
          <InputHint colors={colors}>بر حسب کیلوگرم</InputHint>
        </div>
      </div>

      <div
        className="mt-5 rounded-2xl border px-4 py-3 text-sm leading-7"
        style={{
          borderColor: colors.border,
          backgroundColor: 'rgba(37,99,235,0.08)',
          color: colors.sub,
        }}
      >
        اطلاعات قد، وزن و سن فقط برای شخصی‌سازی برنامه استفاده می‌شود و بهتر است دقیق وارد شود.
      </div>
    </div>
  );
}

function FieldLabel({ children, colors }) {
  return (
    <label
      className="block mb-2 text-sm font-bold"
      style={{ color: colors.text }}
    >
      {children}
    </label>
  );
}

function AppInput({ value, onChange, placeholder, colors }) {
  return (
    <input
      type="tel"
      inputMode="numeric"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full rounded-2xl border px-4 py-4 outline-none text-right transition focus:border-blue-500"
      style={{
        backgroundColor: colors.inputBg,
        borderColor: colors.border,
        color: colors.text,
      }}
    />
  );
}

function ChoiceCard({ active, title, icon, onClick, colors }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-[22px] border p-4 text-right transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 16px 35px rgba(37,99,235,0.18)' : 'none',
      }}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="text-2xl">{icon}</span>
          <span className="font-black">{title}</span>
        </div>

        <span
          className="w-6 h-6 rounded-full border flex items-center justify-center text-xs"
          style={{
            borderColor: active ? '#60a5fa' : colors.border,
            backgroundColor: active ? '#2563eb' : 'transparent',
            color: '#fff',
          }}
        >
          {active ? '✓' : ''}
        </span>
      </div>
    </button>
  );
}

function InputHint({ children, colors }) {
  return (
    <div className="mt-2 text-xs" style={{ color: colors.muted }}>
      {children}
    </div>
  );
}

function normalizeNumber(value) {
  return String(value || '')
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(/[^\d]/g, '');
}